/**
 * Branding Constants
 * URLs for logo and icon assets
 * 
 * Update these URLs with your actual hosted logo and icon files
 */

// Base URL for assets - Update this to your CDN or hosting location
export const ASSETS_BASE_URL = 'https://complin.ai';

// Logo and Icon URLs
export const LOGO_URL = `${ASSETS_BASE_URL}/logo.png`; // Full logo with text (recommended: 200x50px or similar)
export const ICON_URL = `${ASSETS_BASE_URL}/icon.png`; // Icon only (recommended: 512x512px, square)
export const FAVICON_URL = `${ASSETS_BASE_URL}/favicon.ico`; // Favicon (recommended: 32x32px or 64x64px)

// Alternative formats
export const LOGO_SVG_URL = `${ASSETS_BASE_URL}/logo.svg`; // SVG version (scalable)
export const ICON_SVG_URL = `${ASSETS_BASE_URL}/icon.svg`; // SVG icon (scalable)

/**
 * Recommended image specifications:
 * 
 * Logo (logo.png):
 * - Dimensions: 200x50px (or proportional)
 * - Format: PNG with transparency
 * - Use case: Header, navigation bars
 * 
 * Icon (icon.png):
 * - Dimensions: 512x512px (square)
 * - Format: PNG with transparency
 * - Use case: App icons, favicons, collapsed sidebar
 * 
 * Favicon (favicon.ico):
 * - Dimensions: 32x32px or 64x64px
 * - Format: ICO or PNG
 * - Use case: Browser tab icon
 * 
 * SVG versions (optional but recommended):
 * - Vector format for crisp display at any size
 * - Use for logo.svg and icon.svg
 */

